import { render } from "./EditPolicies.vue?vue&type=template&id=bd7e3cdc&scoped=true"
import script from "./EditPolicies.vue?vue&type=script&lang=js"
export * from "./EditPolicies.vue?vue&type=script&lang=js"

import "./EditPolicies.vue?vue&type=style&index=0&id=bd7e3cdc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bd7e3cdc"

export default script